/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Selected_UserInputs */

const en_selected_user = /** @type {(inputs: Selected_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected User`)
};

const es_selected_user = /** @type {(inputs: Selected_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuario seleccionado`)
};

/**
* | output |
* | --- |
* | "Selected User" |
*
* @param {Selected_UserInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const selected_user = /** @type {((inputs?: Selected_UserInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selected_UserInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_selected_user(inputs)
	return es_selected_user(inputs)
});